import { useSharedValue } from "react-native-reanimated";
import { UseKeyboardSVType } from "./types";

const useKeyboardSV: UseKeyboardSVType = () => {
	const keyboardHeightSV = useSharedValue(0);

	return {
		keyboardSV: keyboardHeightSV,
	};
};
export default useKeyboardSV;
